import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
body {
  font-family: ${(props) => props.theme.variables.fontFamilyBase};
  font-size: ${(props) => props.theme.variables.fontSizeBase};
  color: ${(props) => props.theme.variables.textColor};
  background-color: ${(props) => props.theme.variables.bodyBg};
  line-height: ${(props) => props.theme.variables.lineHeightBase};
}
h1 {
font-size: 1.25rem;
font-weight: bold;
text-transform: uppercase;
}
h2 {
font-size: 1.125rem;
font-weight: bold;
text-transform: uppercase;
}
h3 {
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
}
h4 {
  font-size: 0.875rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height:1.875rem;
}
.body1{
  font-size: 0.875rem;
  font-weight: normal;
}
.body2{
  font-size: 0.75rem;
  font-weight: normal;
}
@media print {
  .no-print { 
    display: none; 
  }
   .grid-print-class
   {grid-row-start: 1 !important;
    grid-column-start: 1 !important;
    grid-column-end: span 2 ;
    grid-row-end:span 2 !important; 
    position: absolute;overflow: auto;
  }
}

`;

export default GlobalStyle;
